import { Box, styled } from '@mui/material';
import * as React from 'react';

export interface QuickReplyOption {
  label: string;
  value: string;
}

interface Props {
  options: QuickReplyOption[];
  onSelect: (value: string) => void;
  disabled?: boolean;
}

export function QuickReplies({ options, onSelect, disabled }: Props) {
  return (
    <SuggestionList>
      {options.map((option) => (
        <SuggestionBtn
          key={option.value}
          type={'button'}
          disabled={disabled}
          onClick={() => onSelect(option.value)}
        >
          {option.label}
        </SuggestionBtn>
      ))}
    </SuggestionList>
  );
}

// ─── Styled — matches apps/ai-consumer chat-bubble-stream.tsx SuggestionList ──

const SuggestionList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  width: '100%',
});

const SuggestionBtn = styled('button')({
  width: '100%',
  textAlign: 'left',
  background: '#eff6ff',
  border: '1px solid transparent',
  borderRadius: 12,
  padding: '10px 12px',
  fontSize: '0.8125rem',
  fontWeight: 500,
  color: '#1e3a8a',
  cursor: 'pointer',
  transition: 'background 150ms',
  fontFamily: 'inherit',
  lineHeight: 1.4,
  '&:hover': { background: '#dbeafe' },
  '&:disabled': { opacity: 0.5, cursor: 'default' },
});
